import axios from 'axios';

export default {
  getVettingPlans() {
    return axios.get('/vetting-plans');
  },
};
